import {FormArray, FormControl, FormGroup} from '@angular/forms';

type AbstractControlOf<T> =
  [T] extends [Array<infer U>] ? FormArray<FormControl<U | null>> :
  [T] extends [object] ? FormGroup<FormControlsOf<T | null>> :
  FormControl<T | null>;

export type FormControlsOf<T> = {
  [K in keyof T]: AbstractControlOf<T[K]>;
};

export class FormAndControls<T> {
  readonly form: FormGroup<FormControlsOf<T>>;

  constructor(public readonly controls: FormControlsOf<T>) {
    this.form = new FormGroup(controls);
  }

  get valid() {
    return this.form.valid;
  }

  get invalid() {
    return this.form.invalid;
  }

  get value() {
    return this.form.value;
  }
}
